import { RootState } from '@redux/store'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { PlayerStatus } from '@types'

const initialState: {
  status: PlayerStatus
  url: string
  /** Display name of the station behind `url`, when the caller knows it. */
  name: string
  /** Station id behind `url`, when the caller knows it. Used for attribution. */
  stationId: string
  action: 'play' | 'pause'
} = {
  status: 'paused',
  url: '',
  name: '',
  stationId: '',
  action: 'pause'
}

const playerSlice = createSlice({
  name: 'stations',
  initialState,
  reducers: {
    setPlaying: (state) => {      
      state.status = 'playing'
    },
    setPaused: (state) => {
      state.status = 'paused'
    },
    setLoading: (state) => {
      state.status = 'loading'
    },
    // Accepts a bare url (old call sites) or { url, name, id }.
    play: (state, action: PayloadAction<string | { url: string, name?: string, id?: string }>) => {
      const payload = typeof action.payload === 'string'? { url: action.payload }: action.payload
      state.url = payload.url
      state.name = payload.name || ''
      state.stationId = payload.id || ''
    },
    pause: (state) => {
      state.url = ''
      state.name = ''
      state.stationId = ''
    }
  }
})

export const { setPlaying, play, pause, setLoading, setPaused } = playerSlice.actions
export const selectPlayerStatus = (state: RootState) => state.player.status
export const selectPlayer = (state: RootState) => state.player

export default playerSlice.reducer
